import { render } from "./Home.vue?vue&type=template&id=1c8e9d43"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=1c8e9d43&lang=css"
script.render = render

export default script